import React, { Component, Fragment } from "react";

import { AiOutlineFileImage, AiOutlineVideoCameraAdd, AiOutlineAppstoreAdd, AiFillDelete } from "react-icons/ai";
import { FaSpinner } from "react-icons/fa";

import * as Constant from "@app/Constant.js";

import axios from "@app/lib/axios";

class Account extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: true,
            msg: "",
            id: this.props.id || 0,
            account: this.props.account || {},
        };
    }

    getAccount = () => {
        this.setState({ isLoaded: false, msg: "데이터 로딩 중입니다." }, () => {
            axios({
                method: "get",
                url: Constant.API_DOMAIN + `/api/tomoplay/parent/account/${this.props.id}`,
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        this.setState({
                            isLoaded: true,
                            account: result.data.account,
                        });
                    } else {
                        alert(result.data.msg);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        });
    };

    resetPass = () => {
        if (window.confirm("비밀번호를 초기화하시겠습니까?\n선택하신 계정의 비밀번호가 1234ab 로 초기화 됩니다.")) {
            axios({
                method: "put",
                url: Constant.API_DOMAIN + `/api/tomoplay/parent/resetPass/${this.state.account.id}`,
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        alert(result.data.msg);
                    } else {
                        alert(result.data.msg);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    };

    updateInfo = (info) => {
        if (window.confirm("계정 정보를 변경하시겠습니까?")) {
            axios({
                method: "post",
                url: Constant.API_DOMAIN + `/api/tomoplay/parent/${this.state.account.id}`,
                data: { info: info },
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        alert(result.data.msg);
                        document.location.reload();
                    } else {
                        alert(result.data.msg);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    };

    render() {
        if (this.state.isLoaded) {
            const account = this.state.account;
            var statusWord = "";            
            if (account.status === "deleted") {
                statusWord = "탈퇴";
            } else {
                statusWord += "토모플레이: ";
                if(account.isLegacy || account.agreeTomoplay) {
                    statusWord += "가입(" + (account.isLegacy ? account.createDateTomoplay : account.agreeTomoplay) + ")";
                } else {
                    statusWord += "미가입";
                }
                statusWord += " / 젤링: ";
                if(account.agreeJelliing) {
                    statusWord += "가입(" + account.agreeJelliing + ")";
                } else {
                    statusWord += "미가입";
                }
            }

            return (
                <Fragment>
                    <h5>계정 정보</h5>
                    <div className="card border-top ">
                        <table className="table table-bordered">
                            <tr>
                                <th className="bg-light">ID</th>
                                <td>
                                    <span>{account.user_id}</span>
                                    <span className="float-right">
                                        <button className="btn btn-sm btn-info" onClick={this.resetPass}>
                                            비밀번호 초기화
                                        </button>
                                    </span>
                                </td>
                                <th className="bg-light">계정 상태</th>
                                <td>
                                        {
                                            account.status === "deleted" ? (
                                                <span className="text-danger">탈퇴</span>
                                            ) : (
                                                <>
                                                    <span className="text-primary mr-3">
                                                        토모플레이: 
                                                        {account.isLegacy || account.agreeTomoplay ? (
                                                            <span className="ml-1 text-success">가입({account.isLegacy ? account.createDate : account.agreeTomoplay})</span>
                                                        ) : (
                                                            <span className="ml-1 text-gray">미가입</span>
                                                        )}
                                                    </span>
                                                    <span className="text-primary mr-3">
                                                        젤링: 
                                                        {account.agreeJelliing ? (
                                                            <span className="ml-1 text-success">가입({account.agreeJelliing})</span>
                                                        ) : (
                                                            <span className="ml-1 text-gray">미가입</span>
                                                        )}
                                                    </span>
                                                </>
                                            )
                                        }
                                    <span className="float-right">
                                    {account.test ? (
                                        <span className="badge badge-secondary mr-1">테스트 계정</span>
                                    ) : (
                                        <span className="badge badge-success mr-1">일반 계정</span>
                                    )}
                                        <button className="btn btn-sm btn-outline-secondary" onClick={(e) => this.updateInfo({ test: account.test ? 0 : 1 })}>
                                            {account.test ? "일반" : "테스트"} 계정으로 변경
                                        </button>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <th className="bg-light">휴대폰 번호</th>
                                <td>{account.mobile}</td>
                                <th className="bg-light">이메일</th>
                                <td>{account.email}</td>
                            </tr>
                            <tr>
                                <th className="bg-light">가입 일시</th>
                                <td>{account.create_date}</td>
                                <th className="bg-light">탈퇴 일시</th>
                                <td>{account.status === "deleted" ? account.update_date : ""}</td>
                            </tr>
                        </table>
                    </div>
                </Fragment>
            );
        } else {
            return (
                <Fragment>
                    <h5>계정 정보</h5>
                    <div className="card border-top">
                        <div className="card-body" style={{ height: this.props.height + "px", textAlign: "center", padding: "50px" }}>
                            <span className="dashboard-spinner spinner-xxl"></span>
                            <div style={{ marginTop: "15px" }}>
                                <p>{this.state.msg}</p>
                                <p>{this.state.uploading}</p>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
        }
    }
}

export default Account;
